import { LanguageCodes } from '@customer-apps/shared/enums';
import { EnumDictionary } from '@customer-apps/shared/utils';

export const LanguageDictionary: EnumDictionary<LanguageCodes, string> = {
    [LanguageCodes.de]: 'LANGUAGE.GERMAN',
    [LanguageCodes.en]: 'LANGUAGE.ENGLISH',
    [LanguageCodes.fr]: 'LANGUAGE.FRENCH',
    [LanguageCodes.nl]: 'LANGUAGE.DUTCH'
};
